module.exports = __webpack_public_path__ + "img/39.ee60ae2b.webp";